import type { ReactNode } from 'react';

interface MockedValueProps {
  children: ReactNode;
  /** What backend work would replace this value. Shown in the tooltip. */
  pending: string;
  /** When true, render inline (default) vs as a block wrapper. */
  inline?: boolean;
}

/**
 * Visual marker for placeholder data that's awaiting backend work.
 * Renders the value with a dashed amber underline and an "MOCK" pip so
 * reviewers can spot what's fake at a glance. The tooltip explains what's
 * pending. Remove the wrapper when the backing work ships.
 */
export default function MockedValue({ children, pending, inline = true }: MockedValueProps) {
  const Tag = inline ? 'span' : 'div';
  return (
    <Tag
      title={`Mocked — pending backend: ${pending}`}
      className="inline-flex items-baseline gap-1 underline decoration-dashed decoration-clay-400 underline-offset-[3px] text-clay-700"
      data-mocked
    >
      {children}
      <span
        aria-hidden
        className="text-[8.5px] font-bold tracking-wider uppercase text-clay-500 align-super -ml-0.5"
      >
        mock
      </span>
    </Tag>
  );
}
